import createIcon from '../../createIcon';

/**
 * @component @name SevenkPlus
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0g1QzMuOSAzIDMgMy45IDMgNVYxOUMzIDIwLjEgMy45IDIxIDUgMjFIMTlDMjAuMSAyMSAyMSAyMC4xIDIxIDE5VjVDMjEgMy45IDIwLjEgMyAxOSAzWk04IDE1SDYuMjVMNy42MyAxMC41SDVWOUg4LjVDOS4xNyA5IDkuNjUgOS42NSA5LjQ2IDEwLjI5TDggMTVaTTE2IDE1SDE0LjI1TDEyLjUgMTIuNzVWMTVIMTFWOUgxMi41VjExLjI1TDE0LjI1IDlIMTZMMTMuNzUgMTJMMTYgMTVaTTIwIDEyLjVIMTguNVYxNEgxNy41VjEyLjVIMTZWMTEuNUgxNy41VjEwSDE4LjVWMTEuNUgyMFYxMi41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SevenkPlus = createIcon('SevenkPlus', [
  [
    'path',
    {
      d: 'M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM8 15H6.25L7.63 10.5H5V9H8.5C9.17 9 9.65 9.65 9.46 10.29L8 15ZM16 15H14.25L12.5 12.75V15H11V9H12.5V11.25L14.25 9H16L13.75 12L16 15ZM20 12.5H18.5V14H17.5V12.5H16V11.5H17.5V10H18.5V11.5H20V12.5Z',
      key: 't921c8',
    },
  ],
]);

export default SevenkPlus;
